export const DEFAULT_LOADING_PROP = 'isLoading';
export const DEFAULT_DATA_PROP = 'data';
export const DEFAULT_ERROR_PROP = 'error';

export const PENDING_PROP_SUFFIX = 'Loading';
export const ERROR_PROP_SUFFIX = 'Error';
export const PENDING_ACTION_TYPE_SUFFIX = 'Pending';
export const SUCCESS_ACTION_TYPE_SUFFIX = 'Success';
export const FAILURE_ACTION_TYPE_SUFFIX = 'Failure';